// extracted by mini-css-extract-plugin
export default {"root":"_380vu","left":"_3qQY7","right":"_3O3cu","small":"_28bc8","normal":"_1bSdC"};